import { InvalidMaxParallelError } from './errors';

/**
 * Processes batches in parallel, with a limit on the number of concurrent batches.
 */
export class ParallelBatchProcessor<T> {
  maxParallel: number;

  constructor(maxParallel: number) {
    if (maxParallel <= 0) {
      throw new InvalidMaxParallelError();
    }
    this.maxParallel = maxParallel;
  }

  async processBatches(batches: T[][], processBatch: (batch: T[]) => Promise<void>): Promise<void> {
    for (let i = 0; i < batches.length; i += this.maxParallel) {
      const parallelBatches = batches.slice(i, i + this.maxParallel);
      await Promise.all(parallelBatches.map(batch => processBatch(batch)));
    }
  }
}
